import { inject, Service } from '@angular/core';
import { TokenProviderService } from '../../../services/token-provider/token-provider.service';
import { Client } from '../../../models/client';

const SESSION_TOKEN_KEY = 'access-token';

@Service()
export class Auth {
  private readonly tokenProvider = inject(TokenProviderService);

  isAuthenticated(): boolean {
    const token = localStorage.getItem(SESSION_TOKEN_KEY);
    if (!token) return false;

    try {
      if (this.tokenProvider.isTokenExpired(token)) {
        this.logout();
        return false;
      }
      return true;
    } catch {
      // Token presente pero no decodificable (corrupto/no es un JWT).
      this.logout();
      return false;
    }
  }

  login(token: string): void {
    localStorage.setItem(SESSION_TOKEN_KEY, token);
  }

  logout(): void {
    localStorage.removeItem(SESSION_TOKEN_KEY);
  }

  getClient(): Client | null {
    const token = localStorage.getItem(SESSION_TOKEN_KEY);
    if (!token) return null;

    try {
      const client = this.tokenProvider.getInfoToken(token)?.client ?? null;
      if (!client) {
        // Token decodifica pero sin `client` (payload inesperado): la
        // sesión no es utilizable, se trata igual que un token corrupto.
        this.logout();
        return null;
      }
      return client;
    } catch {
      // Token presente pero no decodificable (corrupto/no es un JWT): no
      // debe tumbar la app entera al construir HomeLayout/Home, que llaman
      // esto de forma síncrona en el constructor.
      this.logout();
      return null;
    }
  }

  // Como getClient(), pero lanza si no hay client.id (getClient() ya hizo
  // logout()); el caller lo convierte en throwError() en su Observable.
  getClientId(): number {
    const client = this.getClient();
    if (client?.id == null) {
      throw new Error('No se pudo resolver el cliente del token de sesión');
    }
    return client.id;
  }
}
